import { Component } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';

import { EsgRatingMapping } from '../../models';

@Component({
	selector: 'mb-esg-rating-mapping-table',
	templateUrl: './esg-rating-mapping-table.component.html',
	styleUrls: ['./esg-rating-mapping-table.component.scss']
})
export class EsgRatingMappingTableComponent {
	@InjectConfig(ModelsExperienceConfigKey.ESG_RATING_MAPPING) public readonly esgRatingsMapping: Array<EsgRatingMapping> = [];
}
